<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Payouts</h4>
    </div>
    <div class="card-body">
      <v-server-table :name="tableName" :url="`/v1/payouts`" :columns="columns" :options="options" :ref="tableName">
        <template slot="id" slot-scope="props">
          <code>{{ props.row.id }}</code>
        </template>

        <template slot="paymentReference" slot-scope="props">
          <code>{{ props.row.paymentReference }}</code>
        </template>

        <template slot="amount" slot-scope="props">
          <span>{{ props.row.amount | money(props.row.currency) }}</span>
        </template>

        <template slot="destinationType" slot-scope="props">{{ props.row.destinationType | humanize }}</template>

        <template slot="status" slot-scope="props">{{ props.row.status | humanize }}</template>

        <template slot="createdAt" slot-scope="props">
          <div>{{ props.row.createdAt | moment('YYYY-MM-DD') }}</div>
        </template>

        <template slot="links" slot-scope="props">
          <router-link :to="`/payouts/${props.row.id}`" class="btn btn-default btn-sm">
            View &nbsp;
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

import { requestAdapter } from "../../../../helpers/tableHelpers";

const columns = [
  "id",
  "amount",
  "paymentReference",
  "destinationType",
  "createdAt",
  "status",
  "links"
];

export default {
  name: "PayoutsList",
  computed: {
    operator: function () {
      return this.$store.state.operator;
    }
  },
  methods: {

  },
  data() {
    return {
      columns,
      tableName: "payoutsList",
      options: {
        name: this.tableName,
        columnsDropdown: false,
        headings: {
          id: "Payout ID",
          amount: "Amount",
          paymentReference: "Reference",
          createdAt: "Date",
          "reportedConfiguration.isUpToDate": "Software status"
        },
        sortable: _.initial(columns),
        filterable: ["serialNumber", "reference"],
        listColumns: {
          isUpToDate: [
            {
              id: "true",
              text: "Up to date"
            },
            {
              id: "false",
              text: "Out of date"
            }
          ]
        },
        requestAdapter
      }
    };
  }
};
</script>
